import React, { useEffect, useRef, useState } from 'react';
import '../Location.css';
import '../Home.css';
import { FaLongArrowAltRight } from "react-icons/fa";
import { Link } from "react-router-dom";
import Home_Hero_One from '../../images/videos/Tattva Realty Hyderabad Promo.mp4';
import Home_Hero_One_Tablet from '../../images/videos/Tattva Realty Hyderabad Promo (Tab Version).mp4';
import Home_Hero_One_Mobile from '../../images/videos/Tattva Realty Hyderabad Promo (Mobile Version).mp4';
import projects from '../../data/ProjectsData';
import DiscussForm from '../../components/DiscussForm';

function Hyderabad() {
    const [theme, setTheme] = useState('light');

    useEffect(() => {
        window.scrollTo(0, 0);
        const currentTheme = localStorage.getItem('theme') || 'light';
        setTheme(currentTheme);
    }, []);

    const hyderabadProjects = projects.filter(
        (project) => project.location?.toLowerCase() === 'hyderabad'
    );

    const grouped = {
        Flats: hyderabadProjects.filter(p => p.category?.toLowerCase() === 'flats'),
        Villas: hyderabadProjects.filter(p => p.category?.toLowerCase() === 'villas'),
        Plots: hyderabadProjects.filter(p => p.category?.toLowerCase() === 'plots'),
        Commercial: hyderabadProjects.filter(p => p.category?.toLowerCase() === 'commercial')
    };

    const accordionRefs = useRef({});

    useEffect(() => {
        const observerOptions = {
            threshold: 0,
            root: null
        };

        const observerCallback = (entries) => {
            entries.forEach((entry) => {
                const id = entry.target.getAttribute('data-id');
                const collapseElement = document.getElementById(`collapse-${id}`);
                if (!entry.isIntersecting && collapseElement?.classList.contains('show')) {
                    collapseElement.classList.remove('show');
                }
            });
        };

        const observer = new IntersectionObserver(observerCallback, observerOptions);

        Object.entries(accordionRefs.current).forEach(([key, el]) => {
            if (el) observer.observe(el);
        });

        return () => observer.disconnect();
    }, []);

    return (
        <div className='location-main'>
            {/* Hero Section */}
            <div className='about-hero hyd-hero'>
                <div className='about-hero-inner d-flex justify-content-center align-items-center'>
                    <div>
                        <h1 className='syne-title'>HYDERABAD<span className='text-rose'>.</span></h1>
                        <p className='text-center'>
                            <Link to="/" className="text-dark text-decoration-none">Home</Link> /{' '}
                            <Link to="/projects" className="text-dark text-decoration-none">Locations</Link> /{' '}
                            <span className='text-rose'>Hyderabad</span>
                        </p>
                    </div>
                </div>
            </div>

            {/* Video Section */}
            <div className='hyd-main'>
                <video src={Home_Hero_One} autoPlay loop muted className='video-full d-lg-block d-none'></video>
                <video src={Home_Hero_One_Tablet} autoPlay loop muted className='video-full d-md-block d-lg-none d-none'></video>
                <video src={Home_Hero_One_Mobile} autoPlay loop muted className='video-full d-block d-md-none'></video>
            </div>

            {/* Accordion Section */}
            <div className='container py-5'>
                <div className="accordion" id="accordionProjects">
                    {Object.entries(grouped).map(([category, items]) => (
                        <div className="accordion-item" key={category}>
                            <h2 className="accordion-header" id={`heading-${category}`}>
                                <button
                                    className={`accordion-button  collapsed`}
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target={`#collapse-${category}`}
                                    aria-expanded="false"
                                    aria-controls={`collapse-${category}`}
                                >
                                    <h1 className="syne-title mb-0 w-100">{category}<span className="text-rose">.</span></h1>
                                </button>
                            </h2>
                            <div
                                ref={(el) => (accordionRefs.current[category] = el)}
                                data-id={category}
                                id={`collapse-${category}`}
                                className="accordion-collapse collapse"
                                aria-labelledby={`heading-${category}`}
                                data-bs-parent="#accordionProjects"
                            >
                                <div className="accordion-body">
                                    <div className="row">
                                        {items.length > 0 ? (
                                            items.map((project) => (
                                                <div className="col-lg-4 col-md-6 my-3" key={project.id}>
                                                    <Link to={`/projects/${project.id}`} className="text-decoration-none text-dark">
                                                        <div className="home-land-card h-100 shadow-sm">
                                                            <img src={project.image} className="img-fluid home-land-card-img" alt={project.title} />
                                                            <div className={`home-land-card-content p-3 text-center ${theme === 'dark' ? 'bg-dark text-light' : 'bg-white'}`}>
                                                                <h6 className="fw-bold">{project.title}</h6>
                                                                <p className="mb-1">{project.location}</p>
                                                                <div className="home-about-btn text-center">
                                                                    <span className="text-rose">
                                                                        <FaLongArrowAltRight /> Know More
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Link>
                                                </div>

                                            ))
                                        ) : (
                                            <div className="text-center text-muted py-5 w-100">
                                                <h5>Projects are adding soon.</h5>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Discuss Form */}
            <DiscussForm />
        </div>
    );
}

export default Hyderabad;
